export { default } from "./useExternalViewPageTracking";
